import React from "react";
import PropTypes from "prop-types";

import useSheetStack from "../common/useSheetStack";
import SheetStack from "../common/SheetStack";
import { ALG_V2_ADD, ALG_V2_EDIT } from "./events";
import AllergyForm from "./AllergyForm";

/**
 * Allergy editor rail — a STACK of write sheets, newest on top.
 *
 * All of the stack behaviour (the blank-sheet guard, one-sheet-per-record,
 * serialised saves, the refusal pulse, the live region) lives in
 * ../common/useSheetStack + ../common/SheetStack, which every v3 rail shares.
 * This file is now only the section's wiring: which events open a sheet, how
 * to pull an allergy out of an edit payload, and what to call each sheet.
 *
 * The header CTA emits ALG_V2_ADD (blank sheet); a row-name click emits
 * ALG_V2_EDIT with the record. Both halves of the old dual-purpose modal live
 * in the rail; the form itself is AllergyForm.
 */

const ADD = [ALG_V2_ADD];
const EDIT = [ALG_V2_EDIT];

const getRecord = (payload) => payload && payload.allergy;
const getRecordId = (a) => a && a.allergyId;
const dupMessage = (a) => `${a.name} is already open for update.`;

const AllergyEditor = ({ patient }) => {
  const patientId = patient && (patient.id || patient.patientID);

  const stack = useSheetStack({
    sectionKey: "allergies",
    addEvents: ADD,
    editEvents: EDIT,
    getRecord,
    getRecordId,
    blankMessage: "A blank allergy form is already open.",
    dupMessage,
    enabled: !!patientId,
  });

  if (!patientId) {
    return <div className="ph-slot-empty is-editor"><p>Waiting for patient…</p></div>;
  }

  return (
    <SheetStack
      stack={stack}
      className="cc3-editor"
      describe={(s) => (s.editing ? `Update ${s.editing.name}` : "Add allergy")}
    >
      {(sheet, props) => <AllergyForm patientId={patientId} {...props} />}
    </SheetStack>
  );
};

AllergyEditor.propTypes = {
  patient: PropTypes.object,
};

export default AllergyEditor;
